import React, { type FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from 'bootstrap';
import { Button, Dialog } from 'shamrock-clover-ui';
import { TrialExtensionForm } from './TrialExtensionForm';
import css from './styles/trialExtensionPopUp.scss';

interface TrialExtProps {
  setShowExtForm: React.Dispatch<React.SetStateAction<boolean>>
};

export const TrialExtensionPopUp: FC<TrialExtProps> = (props) => {
  const [isDialogOpen, setIsDialogOpen] = useState(true);
  const [isModalForm, setIsModalForm] = useState(false);
  const Component = isModalForm ? FormModal : RequestModal;

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const openModalForm = () => {
    setIsModalForm(true);
  }

  return (
    <Component closeDialog={closeDialog} openModalForm={openModalForm} isOpen={isDialogOpen} {...props} />
  );
};

interface RequestModalProps extends TrialExtProps {
  closeDialog: () => void;
  openModalForm: () => void;
  isOpen: boolean;
}

const RequestModal: FC<RequestModalProps> = ({ closeDialog, isOpen, ...props }) => (
  <Dialog
    onClose={closeDialog}
    content={<RequestContent />}
    actions={<RequestButtons {...props} closeDialog={closeDialog} />}
    open={isOpen}
  />
);

const RequestContent = () => {
  const { t } = useTranslation();
  const cpua4769Web = useSelector<RootState, boolean>((state) => state.app.features.includes('CPUA-4769-WEB'));

  const headerText = cpua4769Web ? t('trial_extension_modal.expired_header') : 'Credit trial expired';
  const bodyText = cpua4769Web
    ? t('trial_extension_modal.expired_body')
    : 'Your trial has expired. To extend the use of this feature, please submit request.';

  return (
    <>
      <h3 className={css.popUpHeader}>{headerText}</h3>
      <p className={css.popUpBody}>{bodyText}</p>
    </>
  );
};

interface RequestButtonsProps extends TrialExtProps {
  closeDialog: () => void;
  openModalForm: () => void;
}

const RequestButtons: FC<RequestButtonsProps> = ({ setShowExtForm, closeDialog, openModalForm }) => {
  const { t } = useTranslation();
  const cpua4769Web = useSelector<RootState, boolean>((state) => state.app.features.includes('CPUA-4769-WEB'));

  const handleRequestTrialExtension = () => {
    if (cpua4769Web) {
      openModalForm();
    } else {
      setShowExtForm(true);
      closeDialog();
    }
  };
  return (
    <div className={css.actionButtonContainer}>
      <Button buttonStyle="outlined" onClick={closeDialog}>{t('cancel')}</Button>
      <Button color="blue" onClick={handleRequestTrialExtension}>{t('trial_extension_modal.request_extension')}</Button>
    </div>
  );
};

const FormModal: FC<RequestModalProps> = ({ isOpen, closeDialog }) => (
  <div className={css.dialogOverrides}>
    <Dialog
      open={isOpen}
      width="680px"
      onClose={closeDialog}
      content={<TrialExtensionForm />}
    />
  </div>
);
